import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { FilterItem } from '@pos/interfaces/pos-session';
import { AccountingReportBundledSale } from '@accounting/interfaces/accounting-reports';
import Table from '@shared/components/tables/table.vue';
@Component({
  name: 'bc-sale-session-bundled-sales-table',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bc-table': Table,
  },
})
export default class SaleSessionBundledSalesTable extends mixins(AbstractField) {
  @Prop({ type: Boolean, default: true }) readonly fetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: true }) readonly hideCheckColumn: boolean;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  readonly externalBundledSales: AccountingReportBundledSale[];

  localLoading: boolean = false;
  public bundledSalesObservableSubscription = null;
  public bundledSales: AccountingReportBundledSale[] = [];
  public fields = [
    {
      key: 'account',
      headerLabel: this.$t('global.grouped_order_items.account'),
      order: 0,
      thClass: 'w-50',
    },
    {
      key: 'paid',
      headerLabel: this.$t('global.grouped_order_items.paid'),
      order: 1,
      thClass: 'w-50',
    },
  ];

  get loadingSales() {
    return this.loading || this.localLoading;
  }

  set loadingSales(value) {
    this.localLoading = value;
    this.$emit('on-loading-change', value);
  }

  get posSessionId(): number {
    const filters = (this.$attrs?.filters || []) as FilterItem[];
    const filter = filters.find(item => {
      return item?.filterField === 'pos_session_id';
    });
    return filter?.value;
  }

  public mounted() {
    if (this.fetchData) {
      this.getBundledSales();
    }
  }

  get processedBundledSales(): AccountingReportBundledSale[] {
    let itemsToProcess = [];
    if (this.externalBundledSales?.length) {
      itemsToProcess = this.externalBundledSales;
    }
    if (this.bundledSales?.length) {
      itemsToProcess = this.bundledSales;
    }
    return this.processBundledSales(itemsToProcess);
  }

  processBundledSales(bundledSales: AccountingReportBundledSale[]) {
    const items = [];
    let total_paid = 0;
    let total_to_pay = 0;
    let total_invoiced = 0;
    Object.entries(bundledSales).forEach(item => {
      items.push({
        account: item[1].account
          ? item[1].account
          : this.$t('global.grouped_order_items.undefined_account'),
        paid: this.formatAmount(item[1].totalPaid),
        to_pay: this.formatAmount(item[1].totalWaiting),
        invoiced: this.formatAmount(item[1].totalInvoiced),
      });
      total_paid += item[1].totalPaid;
      total_to_pay += item[1].totalWaiting;
      total_invoiced += item[1].totalInvoiced;
    });
    items.push({
      account: this.$t('global.total'),
      paid: this.formatAmount(total_paid),
      to_pay: this.formatAmount(total_to_pay),
      invoiced: this.formatAmount(total_invoiced),
      _rowVariant: 'light',
    });
    return items;
  }

  public getBundledSales() {
    this.loadingSales = true;
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('pos-sessions')}/${
      this.posSessionId
    }/grouped-order-items`;

    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(fetchEntityPath);

    if (this.bundledSalesObservableSubscription) {
      this.bundledSalesObservableSubscription.unsubscribe();
    }

    this.bundledSalesObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.bundledSales = res.data;
        this.loadingSales = false;
      },
      error => {
        console.log(error);
      },
    );
  }

  formatAmount(value: number) {
    return this.$bpcHelper.formatPrice(value);
  }
}
